module.exports = __webpack_public_path__ + "static/book-01@2x-b8c875f9b5e525671b6934f7e7a8fdeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/ebook-design-systems/book-01@2x.jpg
// module id = 2561
// module chunks = 62778679897657